import type { EffectCallback } from 'react';
import { useEffect, useRef } from 'react';

export type OnMountCallback = EffectCallback;

export function useOnMount(callback: OnMountCallback) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current();
  }, []);
}
